import React, { useState } from 'react'
import { Link } from 'gatsby'
import { motion } from 'framer-motion'
import { Col, Row } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronDown, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { useLocation } from '@reach/router'
import { productFilters } from './productListState'

import './product_list_filters.scss'

const listVariants = {
  open: {
    position: 'relative',
    clipPath: 'inset(0% 0% 0% 0% round 10px)',
    transition: {
      type: 'spring',
      bounce: 0,
      duration: 0.7,
      delayChildren: 0.3,
      staggerChildren: 0.05
    }
  },
  closed: {
    position: 'absolute',
    clipPath: 'inset(10% 50% 90% 50% round 10px)',
    transition: {
      type: 'spring',
      bounce: 0,
      duration: 0.3
    }
  }
}

const itemVariants = {
  open: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring', stiffness: 300, damping: 24 }
  },
  closed: { 
    opacity: 0, 
    y: 20, 
    transition: { duration: 0.2 } 
  }
}

const FilterListItem = ({ route, label }) => {
  return (
    <Link to={route}>
      {label}
    </Link>
  )
}

const FilterListItemChildren = ({ id, expanded, route, label, children, isChildRoute }) => {
  const [open, setOpen] = useState(expanded)

  return (
    <>
      <Link to={route}>
        <FontAwesomeIcon icon={open ? faChevronDown : faChevronRight} />
        {label}
      </Link>
      <motion.ul
        initial={isChildRoute ? false : "closed"}
        animate={open ? "open" : "closed"}
        variants={listVariants} 
        className="product-list-filter">
        <FilterListInner id={id} items={children} expanded={open} isChildRoute={isChildRoute} />
      </motion.ul>
    </>
  )
}

const FilterListInner = ({ id, items, expanded, isChildRoute }) => {
  return (
    items.map((filter, index) => {
      return (
        <motion.li key={`${id}-${index}`} variants={itemVariants} animate={expanded ? "open" : "closed"}>
          {filter.children 
            ? <FilterListItemChildren expanded={expanded} isChildRoute={isChildRoute} {...filter} />
            : <FilterListItem {...filter} />
          }
        </motion.li>
      )
    })
  )
}

const FilterList = ({ id, items, parentRoute, isChildRoute }) => {
  return (
    <motion.ul className="product-list-filter-container">
      {items.map((filter, index) => {
        const expanded = filter.route.includes(parentRoute)

        return (
          <motion.li key={`${id}-${index}`}>
            {filter.children 
              ? <FilterListItemChildren expanded={expanded} isChildRoute={isChildRoute} {...filter} />
              : <FilterListItem {...filter} />
            }
          </motion.li>
        )
      })}
    </motion.ul>
  )
}

export const ProductListFilters = () => {
  const { pathname } = useLocation()
  const [, parentRoute] = pathname.split('/').filter(value => value)
  const isChildRoute = pathname.split('/').filter(val => val).length >= 3

  return (
    <Row className="mt-5">
      <Col sm={12}>
        <div className="section-title-container">
          <h3 className="section-title">Products</h3>
        </div>
        <FilterList 
          id={0} 
          items={productFilters} 
          parentRoute={parentRoute}
          isChildRoute={isChildRoute} />
      </Col>
    </Row>
  )
}

export default ProductListFilters